import React, { useEffect, useState } from 'react'

import API from '../../ApiConfig'
import { GET_PDF } from '../../Utils/constant'

export default function PreviewPDF({ doc_id, load, setLoading, type, isMaster = false, isInternal }) {

    const [preview, setPreview] = useState(null)
    const [loadingText, setLoadingText] = useState('Genrating PDF... Please Wait')
    const getPdf = () => {
        setLoading(true)
        API.get(GET_PDF + doc_id + (isInternal?"" :isMaster? '?s3_type=Predefined' : ''))
            .then(response => {
                setPreview(response.data.data[type]);

            }).catch(err => {
                setPreview(false)
                setLoadingText("Error while generating PDF");
            })
            .finally(() =>
                setLoading(false)
            )
    }

    useEffect(() =>
        getPdf(),
        [doc_id]
    )

    var loading = {
        padding: "1rem",
        height: "10vh",
        width: "-webkit-fill-available",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }

    if (load) {
        return (
            <div>Please wait while we load the preview</div>
        )
    }

    // if (!preview) {
    //     return (<div style={loading}>
    //         {loadingText}
    //     </div>)
    // }

    else {
        if (type == 'pdf')
            return (
                <div style={{ width: 'inherit', height: 'inherit' }}>
                    <embed
                        key={preview}
                        id="pdf-viewer"
                        src={preview + "#toolbar=0"}
                        type="application/pdf"
                    />
                </div>
            )
        else {
            return (
                <img src={preview} style={{ width: 'inherit', height: 'inherit', border: '1px solid gray' }}></img>
            )
        }
    }
}
